module.exports = __webpack_public_path__ + "static/media/pic-ht17.af37639e.jpg";